<template>
    <div id="Masters">
        <v-container fluid class="fill-height">
          <v-tabs class="elevation-0" v-model="tab">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab :href="`#tab-${index}`" :key="index" v-for="(tab,index) in tabs">
                        <v-icon class="mr-3" size="18">{{tab.icon}}</v-icon>{{tab.name}}
                    </v-tab>
                    <v-tab-item :key="index" :value="`tab-${index}`" v-for="(tab,index) in tabs">
                        <component :is="tab.component"></component>
                    </v-tab-item>
                </v-tabs>
        </v-container>
    </div>
</template>

<script>
  import UserManagement from '../../components/UserManagement/UserManagement'
  import VehicleManagement from '../../components/VehicleManagement/VehicleManagement'
  import RouteManagement from '../../components/RouteManagement/RouteManagement'

  export default {
    name: 'Masters',
    data () {
      return {
        tab: 'tab-0',
        tabs: [
          { id: 1, icon: 'mdi-account-group', name: 'Users', component: UserManagement },
          { id: 2, icon: 'mdi-truck-delivery', name: 'Vehicles', component: VehicleManagement },
          { id: 3, icon: 'mdi-highway', name: 'Routes', component: RouteManagement },
        ],
      }
    },
  }
</script>

<style scoped>

</style>
